import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { useLocalizedPath } from "@/hooks/useLocalizedNavigate";

const MobileFooter = () => {
  const { t } = useLanguage();
  const lp = useLocalizedPath();

  return (
    <footer className="border-t bg-card py-6 md:hidden">
      <div className="container">
        <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-muted-foreground">
          <Link to={lp("/a-propos")} className="hover:text-primary transition-colors">{t("footer.about")}</Link>
          <span className="text-border">·</span>
          <Link to={lp("/cgu")} className="hover:text-primary transition-colors">{t("footer.cgu")}</Link>
          <span className="text-border">·</span>
          <Link to={lp("/confidentialite")} className="hover:text-primary transition-colors">{t("footer.confidentialite")}</Link>
          <span className="text-border">·</span>
          <a href="mailto:contact@hirafidz.com" className="hover:text-primary transition-colors">{t("footer.contact")}</a>
        </div>
        <p className="mt-3 text-center text-xs text-muted-foreground">{t("footer.copyright", { year: new Date().getFullYear() })}</p>
      </div>
    </footer>
  );
};

export default MobileFooter;
